export const questionsArray = [
  {
    value: "hair-type",
    title: "What type of hair do you have?",
    options: [
      'Straight', "Wavy", "Curly", "Coily"
    ]
  },
  {
    value: "thickness",
    title: "How thick is it?",
    options: [
      "Thick", "Medium", "Thin"
    ]
  },
  {
    value: "length",
    title: "What is your hair length?",
    options: [
      "Chin", "Shoulder", "Collarbone", "Mid Chest", "Rib Cage", "Belly Button"
    ]
  },
  {
    value: "goals",
    title: "What are your hair goals?",
    options: [
      "Length", "Volume", "Volume & Length"
    ]
  },
  {
    value: "plan",
    title: "How do you plan to wear your BFB?",
    options: [
      "Mostly Down", "Braid, Top Knot, Ponytail, Bun"
    ]
  }
]

/////////////////////////////////////////////////////////////////

export const results = [
  {
    productHandle: "ice-breaker-two-piece",
    cardTitle: '35 gram 14" Fill-ins',
    possibleAnswers: [
      ["Straight", "Thin", "Chin", "Volume", "Mostly Down"],
      ["Straight", "Thin", "Shoulder", "Volume", "Mostly Down"],
      ["Straight", "Thin", "Collarbone", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Chin", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Shoulder", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Collarbone", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Chin", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Shoulder", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Collarbone", "Volume", "Mostly Down"],
    ],
  },
  {
    productHandle: "ice-breaker-50-gram-14-fill-ins",
    cardTitle: '50 gram 14" Fill-ins',
    possibleAnswers: [
      ["Straight", "Medium", "Chin", "Volume", "Mostly Down"],
      ["Straight", "Medium", "Shoulder", "Volume", "Mostly Down"],
      ["Straight", "Medium", "Collarbone", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Chin", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Shoulder", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Collarbone", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Chin", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Shoulder", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Collarbone", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Chin", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Shoulder", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Collarbone", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Chin", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Shoulder", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Collarbone", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Chin", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Shoulder", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Collarbone", "Volume", "Mostly Down"],
    ],
  },
  {
    productHandle: "ice-breaker-18-inch-fill-ins",
    cardTitle: '18" Fill-ins',
    possibleAnswers: [
      ["Straight", "Thin", "Mid Chest", "Volume", "Mostly Down"],
      ["Straight", "Thin", "Rib Cage", "Volume", "Mostly Down"],
      ["Straight", "Medium", "Mid Chest", "Volume", "Mostly Down"],
      ["Straight", "Medium", "Rib Cage", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Mid Chest", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Rib Cage", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Mid Chest", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Rib Cage", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Mid Chest", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Rib Cage", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Mid Chest", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Rib Cage", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Mid Chest", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Rib Cage", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Mid Chest", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Rib Cage", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Mid Chest", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Rib Cage", "Volume", "Mostly Down"],
    ],
  },
  {
    productHandle: "ice-breaker-seamless",
    cardTitle: '21" Classic',
    possibleAnswers: [
      ["Straight", "Thin", "Chin", "Length", "Mostly Down"],
      ["Straight", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Straight", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Straight", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Straight", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Straight", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Chin", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Curly", "Thin", "Chin", "Length", "Mostly Down"],
      ["Curly", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Curly", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Curly", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Curly", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Curly", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Straight", "Medium", "Chin", "Volume", "Ponytail"],
      ["Straight", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Straight", "Medium", "Chin", "Length", "Ponytail"],
      ["Straight", "Medium", "Shoulder", "Length", "Ponytail"],
      ["Wavy", "Medium", "Chin", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Chin", "Length", "Ponytail"],
      ["Wavy", "Medium", "Shoulder", "Length", "Ponytail"],
      ["Curly", "Medium", "Chin", "Volume", "Ponytail"],
      ["Curly", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Curly", "Medium", "Chin", "Length", "Ponytail"],
      ["Curly", "Medium", "Shoulder", "Length", "Ponytail"],
    ],
  },
  {
    productHandle: "ice-breaker-up",
    cardTitle: "Updos",
    possibleAnswers: [
      ["Straight", "Thin", "Chin", "Volume", "Ponytail"],
      ["Straight", "Thin", "Shoulder", "Volume", "Ponytail"],
      ["Straight", "Thin", "Collarbone", "Volume", "Ponytail"],
      ["Straight", "Thin", "Mid Chest", "Volume", "Ponytail"],
      ["Straight", "Thin", "Chin", "Length", "Ponytail"],
      ["Straight", "Thin", "Shoulder", "Length", "Ponytail"],
      ["Straight", "Thin", "Collarbone", "Length", "Ponytail"],
      ["Straight", "Thin", "Mid Chest", "Length", "Ponytail"],
      ["Straight", "Medium", "Collarbone", "Volume", "Ponytail"],
      ["Straight", "Medium", "Mid Chest", "Volume", "Ponytail"],
      ["Straight", "Medium", "Collarbone", "Length", "Ponytail"],
      ["Straight", "Medium", "Mid Chest", "Length", "Ponytail"],
      ["Straight", "Thick", "Collarbone", "Volume", "Ponytail"],
      ["Straight", "Thick", "Mid Chest", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Chin", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Shoulder", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Collarbone", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Mid Chest", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Chin", "Length", "Ponytail"],
      ["Wavy", "Thin", "Shoulder", "Length", "Ponytail"],
      ["Wavy", "Thin", "Collarbone", "Length", "Ponytail"],
      ["Wavy", "Thin", "Mid Chest", "Length", "Ponytail"],
      ["Wavy", "Medium", "Collarbone", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Mid Chest", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Collarbone", "Length", "Ponytail"],
      ["Wavy", "Medium", "Mid Chest", "Length", "Ponytail"],
      ["Wavy", "Thick", "Collarbone", "Volume", "Ponytail"],
      ["Wavy", "Thick", "Mid Chest", "Volume", "Ponytail"],
      ["Curly", "Thin", "Chin", "Volume", "Ponytail"],
      ["Curly", "Thin", "Shoulder", "Volume", "Ponytail"],
      ["Curly", "Thin", "Collarbone", "Volume", "Ponytail"],
      ["Curly", "Thin", "Mid Chest", "Volume", "Ponytail"],
      ["Curly", "Thin", "Chin", "Length", "Ponytail"],
      ["Curly", "Thin", "Shoulder", "Length", "Ponytail"],
      ["Curly", "Thin", "Collarbone", "Length", "Ponytail"],
      ["Curly", "Thin", "Mid Chest", "Length", "Ponytail"],
      ["Curly", "Medium", "Collarbone", "Volume", "Ponytail"],
      ["Curly", "Medium", "Mid Chest", "Volume", "Ponytail"],
      ["Curly", "Medium", "Collarbone", "Length", "Ponytail"],
      ["Curly", "Medium", "Mid Chest", "Length", "Ponytail"],
      ["Curly", "Thick", "Collarbone", "Volume", "Ponytail"],
      ["Curly", "Thick", "Mid Chest", "Volume", "Ponytail"],
    ],
  },
  {
    productHandle: "ice-breaker-24-classic",
    cardTitle: '24" Classic',
    possibleAnswers: [
      ["Straight", "Thin", "Belly Button", "Volume", "Mostly Down"],
      ["Straight", "Thin", "Rib Cage", "Length", "Mostly Down"],
      ["Straight", "Thin", "Belly Button", "Length", "Mostly Down"],
      ["Straight", "Medium", "Belly Button", "Volume", "Mostly Down"],
      ["Straight", "Medium", "Chin", "Length", "Mostly Down"],
      ["Straight", "Medium", "Shoulder", "Length", "Mostly Down"],
      ["Straight", "Medium", "Rib Cage", "Length", "Mostly Down"],
      ["Straight", "Medium", "Belly Button", "Length", "Mostly Down"],
      ["Straight", "Thick", "Belly Button", "Volume", "Mostly Down"],
      ["Straight", "Thick", "Chin", "Length", "Mostly Down"],
      ["Straight", "Thick", "Shoulder", "Length", "Mostly Down"],
      ["Straight", "Thick", "Collarbone", "Length", "Mostly Down"],
      ["Straight", "Thick", "Mid Chest", "Length", "Mostly Down"],
      ["Straight", "Thick", "Rib Cage", "Length", "Mostly Down"],
      ["Straight", "Thick", "Belly Button", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Belly Button", "Volume", "Mostly Down"],
      ["Wavy", "Thin", "Rib Cage", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Belly Button", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Belly Button", "Volume", "Mostly Down"],
      ["Wavy", "Medium", "Chin", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Shoulder", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Rib Cage", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Belly Button", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Belly Button", "Volume", "Mostly Down"],
      ["Wavy", "Thick", "Chin", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Shoulder", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Collarbone", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Mid Chest", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Rib Cage", "Length", "Mostly Down"],
      ["Wavy", "Thick", "Belly Button", "Length", "Mostly Down"],
      ["Curly", "Thin", "Belly Button", "Volume", "Mostly Down"],
      ["Curly", "Thin", "Rib Cage", "Length", "Mostly Down"],
      ["Curly", "Thin", "Belly Button", "Length", "Mostly Down"],
      ["Curly", "Medium", "Belly Button", "Volume", "Mostly Down"],
      ["Curly", "Medium", "Chin", "Length", "Mostly Down"],
      ["Curly", "Medium", "Shoulder", "Length", "Mostly Down"],
      ["Curly", "Medium", "Rib Cage", "Length", "Mostly Down"],
      ["Curly", "Medium", "Belly Button", "Length", "Mostly Down"],
      ["Curly", "Thick", "Belly Button", "Volume", "Mostly Down"],
      ["Curly", "Thick", "Chin", "Length", "Mostly Down"],
      ["Curly", "Thick", "Shoulder", "Length", "Mostly Down"],
      ["Curly", "Thick", "Collarbone", "Length", "Mostly Down"],
      ["Curly", "Thick", "Mid Chest", "Length", "Mostly Down"],
      ["Curly", "Thick", "Rib Cage", "Length", "Mostly Down"],
      ["Curly", "Thick", "Belly Button", "Length", "Mostly Down"],
      ["Straight", "Thin", "Rib Cage", "Volume", "Ponytail"],
      ["Straight", "Thin", "Belly Button", "Volume", "Ponytail"],
      ["Straight", "Thin", "Rib Cage", "Length", "Ponytail"],
      ["Straight", "Thin", "Belly Button", "Length", "Ponytail"],
      ["Straight", "Medium", "Rib Cage", "Volume", "Ponytail"],
      ["Straight", "Medium", "Belly Button", "Volume", "Ponytail"],
      ["Straight", "Medium", "Rib Cage", "Length", "Ponytail"],
      ["Straight", "Medium", "Belly Button", "Length", "Ponytail"],
      ["Straight", "Thick", "Chin", "Volume", "Ponytail"],
      ["Straight", "Thick", "Shoulder", "Volume", "Ponytail"],
      ["Straight", "Thick", "Rib Cage", "Volume", "Ponytail"],
      ["Straight", "Thick", "Belly Button", "Volume", "Ponytail"],
      ["Straight", "Thick", "Chin", "Length", "Ponytail"],
      ["Straight", "Thick", "Shoulder", "Length", "Ponytail"],
      ["Straight", "Thick", "Collarbone", "Length", "Ponytail"],
      ["Straight", "Thick", "Mid Chest", "Length", "Ponytail"],
      ["Straight", "Thick", "Rib Cage", "Length", "Ponytail"],
      ["Straight", "Thick", "Belly Button", "Length", "Ponytail"],
      ["Wavy", "Thin", "Rib Cage", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Belly Button", "Volume", "Ponytail"],
      ["Wavy", "Thin", "Rib Cage", "Length", "Ponytail"],
      ["Wavy", "Thin", "Belly Button", "Length", "Ponytail"],
      ["Wavy", "Medium", "Rib Cage", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Belly Button", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Rib Cage", "Length", "Ponytail"],
      ["Wavy", "Medium", "Belly Button", "Length", "Ponytail"],
      ["Wavy", "Thick", "Chin", "Volume", "Ponytail"],
      ["Wavy", "Thick", "Shoulder", "Volume", "Ponytail"],
      ["Wavy", "Thick", "Rib Cage", "Volume", "Ponytail"],
      ["Wavy", "Thick", "Belly Button", "Volume", "Ponytail"],
      ["Wavy", "Thick", "Chin", "Length", "Ponytail"],
      ["Wavy", "Thick", "Shoulder", "Length", "Ponytail"],
      ["Wavy", "Thick", "Collarbone", "Length", "Ponytail"],
      ["Wavy", "Thick", "Mid Chest", "Length", "Ponytail"],
      ["Wavy", "Thick", "Rib Cage", "Length", "Ponytail"],
      ["Wavy", "Thick", "Belly Button", "Length", "Ponytail"],
      ["Curly", "Thin", "Rib Cage", "Volume", "Ponytail"],
      ["Curly", "Thin", "Belly Button", "Volume", "Ponytail"],
      ["Curly", "Thin", "Rib Cage", "Length", "Ponytail"],
      ["Curly", "Thin", "Belly Button", "Length", "Ponytail"],
      ["Curly", "Medium", "Rib Cage", "Volume", "Ponytail"],
      ["Curly", "Medium", "Belly Button", "Volume", "Ponytail"],
      ["Curly", "Medium", "Rib Cage", "Length", "Ponytail"],
      ["Curly", "Medium", "Belly Button", "Length", "Ponytail"],
      ["Curly", "Thick", "Chin", "Volume", "Ponytail"],
      ["Curly", "Thick", "Shoulder", "Volume", "Ponytail"],
      ["Curly", "Thick", "Rib Cage", "Volume", "Ponytail"],
      ["Curly", "Thick", "Belly Button", "Volume", "Ponytail"],
      ["Curly", "Thick", "Chin", "Length", "Ponytail"],
      ["Curly", "Thick", "Shoulder", "Length", "Ponytail"],
      ["Curly", "Thick", "Collarbone", "Length", "Ponytail"],
      ["Curly", "Thick", "Mid Chest", "Length", "Ponytail"],
      ["Curly", "Thick", "Rib Cage", "Length", "Ponytail"],
      ["Curly", "Thick", "Belly Button", "Length", "Ponytail"],
    ],
  },
  {
    productHandle: "autumn-no-show",
    cardTitle: "The No Show",
    possibleAnswers: [
      ["Straight", "Thin", "Chin", "Length", "Mostly Down"],
      ["Straight", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Straight", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Straight", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Straight", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Straight", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Chin", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Wavy", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Wavy", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Curly", "Thin", "Chin", "Length", "Mostly Down"],
      ["Curly", "Thin", "Shoulder", "Length", "Mostly Down"],
      ["Curly", "Thin", "Collarbone", "Length", "Mostly Down"],
      ["Curly", "Thin", "Mid Chest", "Length", "Mostly Down"],
      ["Curly", "Medium", "Collarbone", "Length", "Mostly Down"],
      ["Curly", "Medium", "Mid Chest", "Length", "Mostly Down"],
      ["Straight", "Medium", "Chin", "Volume", "Ponytail"],
      ["Straight", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Straight", "Medium", "Chin", "Length", "Ponytail"],
      ["Straight", "Medium", "Shoulder", "Length", "Ponytail"],
      ["Wavy", "Medium", "Chin", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Wavy", "Medium", "Chin", "Length", "Ponytail"],
      ["Wavy", "Medium", "Shoulder", "Length", "Ponytail"],
      ["Curly", "Medium", "Chin", "Volume", "Ponytail"],
      ["Curly", "Medium", "Shoulder", "Volume", "Ponytail"],
      ["Curly", "Medium", "Chin", "Length", "Ponytail"],
      ["Curly", "Medium", "Shoulder", "Length", "Ponytail"],
    ],
  },
];